import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpContextToken
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

/**
 * Requests that run in the background (e.g. marking a push as read on tap) set this
 * so a 401 does not log the user out and override the navigation in progress.
 */
export const SKIP_UNAUTHORIZED_LOGOUT = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !request.context.get(SKIP_UNAUTHORIZED_LOGOUT)) {
          // Handle the 401 error - log out the user
          this.handleUnauthorized();
        }
        return throwError(() => error);
      })
    );
  }

  private async handleUnauthorized(): Promise<void> {
    // Log out the user
    await this.authService.logout();
    
    // Redirect to login page
    this.router.navigate(['/login']);
  }
}